import { CircularProgress } from '@material-ui/core';
import { X } from 'phosphor-react';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { LaudoAcesso, LaudoExame } from '../use-dashboard';
import * as S from './styles';

interface AcessosDialogProps {
  cdLaudo: string;
  from: LaudoExame['from'];
  nmPaciente?: string;
  handleCloseModal: () => void;
  onFetchAcessos: (
    cdLaudo: string,
    from: LaudoExame['from'],
  ) => Promise<LaudoAcesso[]>;
}

function labelTipoUsuario(tpUsuario: string, cdUsuario: number): string {
  if (tpUsuario === 'M' && cdUsuario === 0) return 'Admin';
  if (tpUsuario === 'M') return 'Médico';
  if (tpUsuario === 'P') return 'Paciente';
  if (tpUsuario === 'B') return 'Business';
  return tpUsuario;
}

export function AcessosDialog({
  cdLaudo,
  from,
  nmPaciente,
  handleCloseModal,
  onFetchAcessos,
}: AcessosDialogProps) {
  const [loading, setLoading] = useState(true);
  const [acessos, setAcessos] = useState<LaudoAcesso[]>([]);

  useEffect(() => {
    let cancelled = false;

    async function loadAcessos() {
      setLoading(true);
      setAcessos([]);

      try {
        const data = await onFetchAcessos(cdLaudo, from);
        if (!cancelled) {
          setAcessos(data);
        }
      } catch (error) {
        if (!cancelled) {
          toast.error('Não foi possível carregar os acessos deste laudo.');
          handleCloseModal();
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    void loadAcessos();

    return () => {
      cancelled = true;
    };
  }, [cdLaudo, from]);

  return (
    <S.AcessosDialogContainer>
      <header>
        <h1>Quem acessou</h1>
        <X size={24} weight="bold" color="black" onClick={handleCloseModal} />
      </header>

      {nmPaciente ? <S.Subtitle>{nmPaciente}</S.Subtitle> : null}

      {loading ? (
        <div style={{ display: 'flex', justifyContent: 'center', padding: 24 }}>
          <CircularProgress color="primary" />
        </div>
      ) : acessos.length === 0 ? (
        <S.EmptyText>Nenhum acesso registrado para este laudo.</S.EmptyText>
      ) : (
        <S.Content>
          {acessos.map((acesso) => (
            <S.AcessoItem
              key={`${acesso.tpUsuario}-${acesso.cdUsuario}-${acesso.dhVisualizacao}`}
            >
              <S.AcessoNome>{acesso.nome || '—'}</S.AcessoNome>
              <S.AcessoMeta>
                Visualizado em {acesso.dhVisualizacao}
              </S.AcessoMeta>
              <S.TipoBadge>
                {labelTipoUsuario(acesso.tpUsuario, acesso.cdUsuario)}
              </S.TipoBadge>
            </S.AcessoItem>
          ))}
        </S.Content>
      )}
    </S.AcessosDialogContainer>
  );
}
